export default {
  tab: {
    all: 'Tüm Ürünler',
    onSelling: 'Satıştakiler',
    outOfStock: 'Tükenenler',
    rejected: 'Reddedilenler',
    notOnSelling: 'Satışta Olmayanlar',
    actionNeeded: 'Kilitli Ürünler',
    archived: 'Arşivlenenler',
  },
};
